// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TCianApiSiteV1QueryToGeoTagsRequest,
  TCianApiSiteV1QueryToGeoTagsModel,
  IMappers,
  TCianApiSiteV1QueryToGeoTagsResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IQueryToGeoTagsResponseSchema72 } from '../../../../entities/schemas/QueryToGeoTagsResponseSchema72';
import type { IErrorResponseSchema73 } from '../../../../entities/schemas/ErrorResponseSchema73';

export function createCianApiSiteV1QueryToGeoTagsModel(
  parameters: TCianApiSiteV1QueryToGeoTagsRequest,
): TCianApiSiteV1QueryToGeoTagsModel {
  return {
    v: 1,
    apiType: 'legacy',
    method: 'POST',
    microserviceName: 'monolith-python',
    pathApi: '/cian-api/site/v1/query-to-geo-tags/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface ICianApiSiteV1QueryToGeoTagsOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TCianApiSiteV1QueryToGeoTagsRequest;
}

export async function fetchCianApiSiteV1QueryToGeoTags<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: ICianApiSiteV1QueryToGeoTagsOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TCianApiSiteV1QueryToGeoTagsResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createCianApiSiteV1QueryToGeoTagsModel(parameters),
    config,
  )) as FetchResponse<TCianApiSiteV1QueryToGeoTagsResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IQueryToGeoTagsResponseSchema72, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema73, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TCianApiSiteV1QueryToGeoTagsResponse>;
}
